// import { Form } from "react-bootstrap";
// import { Note } from "data/crm/dealDetailsData";
// import classNames from "classnames";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { Link } from "react-router-dom";
// import { faClock } from "@fortawesome/free-solid-svg-icons";

// const DealDetailsNotes = ({ notes }: { notes: Note[] }) => {
//   return (
//     <>
//       <h2 className="mb-4">Notes</h2>
//       <Form.Control as="textarea" rows={4} className="mb-3" />
//       {notes.map((note, index) => (
//         <div
//           key={note.id}
//           className={classNames("border-2 border-dashed border-translucent", {
//             "mb-4 pb-4 border-bottom": index !== notes.length - 1,
//           })}
//         >
//           <p className="mb-1 text-body-highlight">{note.description}</p>
//           <div className="d-sm-flex">
//             <div className="fs-9 text-body-tertiary text-opacity-85">
//               <FontAwesomeIcon icon={faClock} className="me-2" />
//               <span className="fw-semibold me-1">{note.date}</span>
//             </div>
//             <p className="fs-9 mb-0 text-body-tertiary text-opacity-85">
//               by
//               <Link to="#!" className="ms-1 fw-semibold">
//                 {note.name}
//               </Link>
//             </p>
//           </div>
//         </div>
//       ))}
//     </>
//   );
// };

// export default DealDetailsNotes;

import { Button, Form } from "react-bootstrap";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "helpers/api";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { dateFormatter } from "helpers/utils";
import { useEffect, useState } from "react";

type Inputs = {
  note: string;
};

const DealDetailsNotes = ({ notes }: any) => {
  const [noteItems, setNoteItems] = useState<any>([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();
  let { id } = useParams();

  useEffect(() => {
    setNoteItems(notes);
  }, [notes]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await axiosInstance.post(`/deals/${id}/notes`, {
        note: data.note,
      });
      toast.success(response.data.message);
      reset();
      setNoteItems((prevNoteItems: any) => [
        ...prevNoteItems,
        {
          note: data.note,
          created_on: Date.now(),
        },
      ]);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <h2 className="mb-4">Notes</h2>

      <Form onSubmit={handleSubmit(onSubmit)} className="mb-5">
        <Form.Control
          as="textarea"
          rows={6}
          className="mb-3"
          {...register("note", { required: true, maxLength: 100 })}
        />
        {errors.note?.type === "required" && (
          <p role="alert" className="text-danger fs-9 pt-1 mb-0">
            Description Required
          </p>
        )}
        <Button variant="primary" type="submit" className="my-0">
          Create Note
        </Button>
      </Form>

      {noteItems?.map((item: any, index: any) => (
        <div
          key={item?.id}
          className={classNames("border-2 border-dashed border-translucent", {
            "mb-4 pb-4 border-bottom": index !== noteItems?.length - 1,
          })}
        >
          <p className="mb-1 text-body-highlight">{item?.note}</p>
          <div className="d-sm-flex">
            <div className="fs-9 text-body-tertiary text-opacity-85">
              <FontAwesomeIcon icon={faClock} className="me-2" />
              <span className="fw-semibold me-1">
                {dateFormatter(item?.created_on)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default DealDetailsNotes;
